import React from 'react';

import styled from 'styled-components';

// constants
import aampeTheme from '../../../constants/aampeTheme';

interface DividerProps {
    text: string;
    textStyle?: {};
    lineStyle?: {};
    containerStyle?: {};
}
interface StyleProps {
    textStyle?: {};
    lineStyle?: {};
    containerStyle?: {};
}

const TextDivider: React.FC<React.PropsWithChildren<DividerProps>> = ({
    text,
    textStyle = {},
    lineStyle = {},
    containerStyle = {},
}) => {
    return (
        <Container style={containerStyle}>
            <GrayLine style={lineStyle} />
            <Text style={textStyle}>{text}</Text>
            <GrayLine style={lineStyle} />
        </Container>
    );
};

export default TextDivider;

const Container = styled.div<{ style: StyleProps }>(({ style }) => ({
    width: '100%',
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    margin: aampeTheme.spacing(4, 0),
    ...style.containerStyle,
}));

const Text = styled.span<{ style: StyleProps }>(({ style }) => ({
    fontSize: '14px',
    color: aampeTheme.colors.textAccessibleWG01,
    fontWeight: 500,
    margin: aampeTheme.spacing(0, 1),
    ...style.textStyle,
}));

const GrayLine = styled.span<{ style: StyleProps }>(({ style }) => ({
    flexGrow: 1,
    height: '1px',
    backgroundColor: aampeTheme.colors.bordersWG01,
    ...style.lineStyle,
}));
